module.exports = __webpack_public_path__ + "img/ios-add-to-homescreen-icon.ab5b5a2e.svg";